exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-card{color:#fff;height:136px;width:217px;background:var(--dark-blue);border-radius:5px;text-align:center;display:flex;box-shadow:6px 6px var(--gray-300);flex-wrap:wrap;flex-shrink:0}.payment-card .card-number{display:flex;font-size:17px;width:100%;text-align:Center;margin-top:30px;justify-content:center}.payment-card .card-bottom{display:flex;justify-content:space-between;width:100%;align-items:flex-end;padding:20px}.payment-card .card-logo{width:60px}.payment-card .card-logo svg{max-width:100%;display:block}.payment-card .card-state{height:26px;width:26px;box-sizing:border-box;display:flex;justify-items:center;align-items:center;border-radius:30px;padding:2px;border:2px solid #fff}.payment-card .card-state.selected{background:#fff}.payment-card .card-state span{display:flex;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/greenmotion-shared/Components/shared/scss/payment-card.scss
// module id = dgKR
// module chunks = 22